module.exports = __webpack_public_path__ + "media/images/PL-fad0e96c.png";